<po-page-list
  [p-title]="tituloPagina"
  [p-breadcrumb]="breadcrumb"
>
  <div class="po-row" *ngIf="!modoInventariar">
    <po-button
      class="po-md-3"
      p-kind="primary"
      p-label="Novo Inventário"
      (p-click)="novoInventario()"
    ></po-button>
  </div>

  <po-table
    class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-striped]="true"
    [p-columns]="colunas"
    [p-items]="itens"
    [p-actions]="acoes"
    p-spacing="small"
    [p-sort]="true"
    [p-hide-columns-manager]="true"
  ></po-table>
</po-page-list>
